import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/build/repo/layouts/default.vue").then(m => m.default || m)),
  home: defineAsyncComponent(() => import("/opt/build/repo/layouts/home.vue").then(m => m.default || m))
}